import BaseService from './_base.service';

export const wishproductService = {
    page,
    search,
    combo,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/wishproduct/page/"+page+"/"+size, callback, true)
}

function search(page,size,filter, callback) {
    return BaseService.post("/wishproduct/page/"+page+"/"+size,filter, callback, true)
}

function combo(callback) {
    return BaseService.get("/wishproduct/combo/", callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/wishproduct/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/wishproduct/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/wishproduct/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/wishproduct/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/wishproduct/"+id+"/logic", callback);
}
